<template>

    <div class="col">
        <p class="step-caption ft-bld">Choose how you want to monetize your content for your users</p>

        <SelectWrapper class="tag-selecter" v-for="plan,index in plans" :key="index"
            :item="plan.name" 
            :caption="plan.description"
            v-model="plan.selected"
            @input="selectPlan(index)"
            :forcedOne="true"
            :billed-price="displayPrices(plan)"
        ></SelectWrapper>

        <div class="new-plan" @click.prevent="addPlan">
            <span class="ico">
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34ZM15.5 15.5V9.5H18.5V15.5H24.5V18.5H18.5V24.5H15.5V18.5H9.5V15.5H15.5Z" fill="url(#paint0_linear_1549_381)"/>
                    <defs>
                    <linearGradient id="paint0_linear_1549_381" x1="34" y1="34" x2="-2.87718" y2="30.524" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#F3CA54"/>
                    <stop offset="1" stop-color="#FFBB36"/>
                    </linearGradient>
                    </defs>
                </svg>
            </span>
            <span class="txt ft-bld txt-main">Add a new subscription plan</span>
        </div>

        <div class="nxt-out">
            <div class="btn bck" @click.prevent="switchStep('prv')">
                <span class="txt">Back</span>
            </div>
            <div class="btn main txt-blk" @click.prevent="submit">
                <span class="hvr"></span>
                <span class="txt">All done!</span>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import SelectWrapper from '../../components/SelectWrapper'

    export default {

        name: 'NewContentThree',

        components: {
            SelectWrapper
        },

        data() {
            return {
                Global,
                plans: [],
            }
        },

        mounted() {

            this.Global.plans.slice(0,2).forEach((plan, index) => {
                plan.selected = index === 0 
                this.plans.push(plan)
            })
        },

        methods: {

            switchStep(dir) {
                this.$emit(dir)
            }, 
            
            async selectPlan(index) {
                
                for (const planIndex in this.plans) {
                    
                    if(index == planIndex) {
                        this.Global.newContentOverlay.planIndex = index
                        continue
                    }
                    
                    this.plans[planIndex].selected = false
                }
            },

            displayPrices(plan) {

                switch (plan.model) {
                    case "monthly":
                        return this.floatToPrice(plan.monthlyPrice) + '€/month'
                    case "annualy":
                        return this.floatToPrice(plan.yearlyPrice) + '€/year'
                    case "both":
                        return this.floatToPrice(plan.monthlyPrice) + '€/month or ' + this.floatToPrice(plan.yearlyPrice) + '€/year'
                    default:
                        return ''
                }
            },

            floatToPrice(float) {
                if(float === null) return this.floatToPrice(0)
                return float.toFixed(2).replace(/\./g, ",")
            },

            async submit() {
                this.Global.assets.push(Object.assign({}, this.Global.newContentOverlay))
                await this.$parent.closeContentOverlay()
                this.resetForm()
            },

            resetForm() {
                this.Global.newContentOverlay = {
                    name: null,
                    tags: [],
                    description: null,
                    video: null,
                    poster: null,
                    planIndex: 0
                }
            },

            async addPlan() {
                this.Global.returnToContent = true
                await this.$parent.closeContentOverlay()
                await this.$parent.$parent.openPlanOverlay()
            }
        }
    }

</script>